<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="meetings-header d-flex flex-wrap justify-content-between align-items-start m-2 m-md-4">
            <div class="meetings-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()" aria-label="Go back to Meetings">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to Meetings
                </button>
                <div class="d-flex flex-wrap align-items-center gap-2 gap-md-3 mb-2">
                    <h3 class="mb-0 meeting-title">{{ meetingDetails?.title || meetingId }}</h3>
                    <app-status-badge 
                        [text]="meetingDetails?.status || ''"
                        [color]="getStatusColor(meetingDetails?.status || '')"
                        [size]="'medium'">
                    </app-status-badge>
                </div>
                <div class="meeting-details-info d-flex flex-wrap gap-4 mt-2">
                    <div class="detail-item d-flex align-items-center gap-2">
                        <i class="fas fa-calendar-alt"></i>
                        <span>{{ meetingDetails?.dateTime | date: 'MMMM d, yyyy' }}</span>
                    </div>
                    <div class="detail-item d-flex align-items-center gap-2">
                        <i class="fas fa-clock"></i>
                        <span>{{ meetingDetails?.dateTime | date: 'h:mm a' }} ({{ meetingDetails?.duration }})</span>
                    </div>
                    <div class="detail-item d-flex align-items-center gap-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="location-icon">
                            <rect x="2" y="3" width="12" height="9" rx="1" stroke="#532E60" stroke-width="1.5" fill="#F8F5FA"/>
                            <rect x="4" y="5" width="8" height="5" rx="0.5" fill="#532E60" fill-opacity="0.2"/>
                        </svg>
                        <span>{{ meetingDetails?.location }}</span>
                    </div>
                </div>
                <span class="breadcrumb-section mt-2">
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="meetings-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.MEETINGS]" class="meetings-header-title breadcrumb-link">Meetings <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>View Meeting</span>
                </span>
            </div>
            <div class="d-flex align-items-center gap-3 action-buttons-header">
                <button 
                    *ngIf="isSecretary()"
                    class="btn action-btn-white" 
                    (click)="editMeeting()" 
                    aria-label="Edit">
                    Edit
                </button>
                <button 
                    *ngIf="isSecretary()"
                    class="btn action-btn-white" 
                    (click)="cancelMeeting()" 
                    aria-label="Cancel">
                    Cancel
                </button>
                <button 
                    *ngIf="canShowJoinMeetingButton() && !demoMode"
                    class="btn action-btn-purple" 
                    (click)="joinMeeting()" 
                    [disabled]="isDialogOpen"
                    aria-label="Join Meeting">
                    Join Meeting
                </button>
                <button
                    *ngIf="canShowJoinMeetingButton() && demoMode"
                    class="btn action-btn-purple"
                    (click)="joinMeeting('admin')"
                    [disabled]="isDialogOpen"
                    aria-label="Join as Admin">
                    Join as Admin
                </button>
                <button
                    *ngIf="canShowJoinMeetingButton() && demoMode"
                    class="btn action-btn-white"
                    (click)="joinMeeting('member')"
                    [disabled]="isDialogOpen"
                    aria-label="Join as Member">
                    Join as Member
                </button>
                <button 
                    *ngIf="canStartMeeting()"
                    class="btn action-btn-purple" 
                    (click)="startMeeting()" 
                    aria-label="Start Meeting">
                    Start Meeting
                </button>
                <button 
                    *ngIf="isSecretary()"
                    class="btn action-btn-pink" 
                    (click)="publishMeeting()" 
                    aria-label="Publish Meeting">
                    Publish Meeting
                </button>
            </div>
        </div>

        <!-- Main Content - Two Column Layout -->
        <div class="row m-2 m-md-4">
            <fieldset class="content-fieldset mb-4">
            <!-- Left Column -->
            <div class="col-12 col-md-8 mb-4 mb-md-0">
                <!-- Agenda Items Section -->
                <fieldset class="content-fieldset mb-4">
                    <legend class="section-legend">Agenda Items</legend>
                    <div class="table-responsive" *ngIf="meetingDetails?.agendaItems && meetingDetails!.agendaItems.length > 0">
                        <table class="agenda-items-table-view">
                            <thead>
                                <tr>
                                    <th>Item #</th>
                                    <th style="display: none;">Attachments</th>
                                    <th>Subject</th>
                                    <th>Actions</th>
                                    <th style="display: none;">Date/Time</th>
                                    <th style="display: none;">Department</th>
                                    <th style="display: none;">Response</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of meetingDetails!.agendaItems; trackBy: trackByAgendaItem; let i = index">
                                    <td data-label="Item #">
                                        <span class="item-number-badge">{{ item.order || (i + 1) }}</span>
                                    </td>
                                    <td data-label="Attachments" style="display: none;">
                                        <button class="btn documents-btn attachments-icon-btn" (click)="openAttachmentsDialog(item)" aria-label="View Attachments">
                                            <i class="fas fa-paperclip"></i>
                                            <span *ngIf="(item.attachmentsCount || 0) > 0" class="badge ms-1">{{ item.attachmentsCount }}</span>
                                        </button>
                                    </td>
                                    <td data-label="Subject">
                                        <div class="subject-content">
                                            <div class="subject-text">{{ item.subject }}</div>
                                        </div>
                                    </td>
                                    <td data-label="Actions">
                                        <div class="action-buttons-container">
                                            <button class="btn btn-sm btn-primary view-details-btn" (click)="openAgendaItemDetails(item)" aria-label="View Details">
                                                <i class="fas fa-eye me-1"></i>
                                                View Details
                                            </button>
                                            <button 
                                                *ngIf="isSecretary()"
                                                class="btn btn-sm btn-secondary edit-agenda-btn" 
                                                (click)="openEditAgendaItem(item)" 
                                                aria-label="Edit Agenda">
                                                <i class="fas fa-edit me-1"></i>
                                                Edit Agenda
                                            </button>
                                        </div>
                                    </td>
                                    <td data-label="Date/Time" style="display: none;">{{ item.dateTime }}</td>
                                    <td data-label="Department" style="display: none;">{{ item.department }}</td>
                                    <td data-label="Response" style="display: none;">
                                        <app-status-badge 
                                            [text]="item.response || 'N/A'"
                                            [color]="getAgendaResponseColor(item.response || '')"
                                            [size]="'small'">
                                        </app-status-badge>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </fieldset>

                <!-- Meeting Notes Section -->
                <fieldset class="content-fieldset mb-4" *ngIf="meetingDetails?.agendaNotes">
                    <legend class="section-legend">Meeting Notes</legend>
                    <div class="meeting-notes-content">
                        <div class="meeting-notes-text">
                            <p class="notes-paragraph">{{ meetingDetails.agendaNotes }}</p>
                        </div>
                    </div>
                </fieldset>

                <!-- Meeting Minutes Section - Only show when meeting status is Completed -->
                <fieldset class="content-fieldset mb-4" *ngIf="isMeetingCompleted()">
                    <legend class="section-legend">Meeting Minutes</legend>
                    
                    <!-- Attendance Table Container -->
                    <div class="attendance-container mb-4" *ngIf="attendanceTableData && attendanceTableData.length > 0">
                        <h5 class="attendance-title mb-3">Attendance :</h5>
                        <div class="table-responsive">
                            <table class="attendance-table-view">
                                <thead>
                                    <tr>
                                        <th>الرقم</th>
                                        <th>اسم العضو</th>
                                        <th>الصفة</th>
                                        <th>حضور الإجتماع</th>
                                        <th>Role</th>
                                        <th>Member Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let member of attendanceTableData; trackBy: trackByAttendanceMember">
                                        <td>{{ member.number }}</td>
                                        <td>{{ member.memberNameArabic }}</td>
                                        <td>{{ member.roleArabic }}</td>
                                        <td>
                                            <svg *ngIf="member.attendance" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="check-icon">
                                                <path d="M9.99935 18.3332C14.6017 18.3332 18.3327 14.6022 18.3327 9.99984C18.3327 5.39746 14.6017 1.6665 9.99935 1.6665C5.39698 1.6665 1.66602 5.39746 1.66602 9.99984C1.66602 14.6022 5.39698 18.3332 9.99935 18.3332Z" stroke="#00A63E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M7.5 10.0002L9.16667 11.6668L12.5 8.3335" stroke="#00A63E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <svg *ngIf="!member.attendance" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="x-icon">
                                                <circle cx="10" cy="10" r="9" fill="#E63956" stroke="#E63956"/>
                                                <path d="M6 6L14 14M14 6L6 14" stroke="white" stroke-width="2" stroke-linecap="round"/>
                                            </svg>
                                        </td>
                                        <td>{{ member.roleEnglish }}</td>
                                        <td>{{ member.memberNameEnglish }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Agenda Items with Decisions -->
                    <div class="agenda-decisions-container mb-4" *ngIf="agendaItemsWithDecisions && agendaItemsWithDecisions.length > 0">
                        <h5 class="decisions-title mb-3">Decisions :</h5>
                        <div class="agenda-item-decision" *ngFor="let item of agendaItemsWithDecisions; let i = index">
                            <h5 class="item-header mb-3">Item #{{ item.order || (i + 1) }} - {{ item.subject || item.itemNumber }}</h5>
                            <div class="item-content-wrapper">
                                <div class="item-content-english">
                                    <p class="decision-label">Tender Committee Decision:</p>
                                    <div class="decision-text" [innerHTML]="getTrustedDecisionHtml(item.decisionEnglish, 'No TC Decision in English...')"></div>
                                </div>
                                <div class="item-separator"></div>
                                <div class="item-content-arabic">
                                    <p class="decision-label">قرار لجنة المناقصات:</p>
                                    <div class="decision-text" [innerHTML]="getTrustedDecisionHtml(item.decisionArabic, 'No TC Decision in Arabic...')"></div>
                                </div>
                            </div>
                            <div class="voting-status-table" *ngIf="item.totalVotes > 0">
                                <table class="voting-table">
                                    <thead>
                                        <tr>
                                            <th>Voting Status</th>
                                            <th>حالة التصويت</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="vote-row">
                                                    <span class="vote-count accepted" *ngIf="item.acceptedVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#00A63E" stroke="#00A63E"/>
                                                            <path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        {{ item.acceptedVotes }} Accepted
                                                    </span>
                                                    <span class="vote-count rejected" *ngIf="item.rejectedVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#E63956" stroke="#E63956"/>
                                                            <path d="M5 5L11 11M11 5L5 11" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                        </svg>
                                                        {{ item.rejectedVotes }} Rejected
                                                    </span>
                                                    <span class="vote-count deferred" *ngIf="item.deferredVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#E46A11" stroke="#E46A11"/>
                                                            <path d="M8 4V8L10 10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        {{ item.deferredVotes }} Deferred
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="vote-row">
                                                    <span class="vote-count accepted" *ngIf="item.acceptedVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#00A63E" stroke="#00A63E"/>
                                                            <path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        {{ item.acceptedVotes }} قبول
                                                    </span>
                                                    <span class="vote-count rejected" *ngIf="item.rejectedVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#E63956" stroke="#E63956"/>
                                                            <path d="M5 5L11 11M11 5L5 11" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                                        </svg>
                                                        {{ item.rejectedVotes }} رفض
                                                    </span>
                                                    <span class="vote-count deferred" *ngIf="item.deferredVotes > 0">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="vote-icon">
                                                            <circle cx="8" cy="8" r="7" fill="#E46A11" stroke="#E46A11"/>
                                                            <path d="M8 4V8L10 10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        {{ item.deferredVotes }} تأجيل
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="meeting-minutes-content" *ngIf="meetingDetails?.meetingMinutesData">
                        <!-- Header -->
                        <div class="meeting-minutes-header d-flex justify-content-between align-items-start mb-4">
                            <h4 class="meeting-minutes-title mb-0">Meeting Minutes</h4>
                            <div class="recorded-by-info">
                                Recorded by {{ meetingDetails!.meetingMinutesData.recordedBy }} on {{ meetingDetails!.meetingMinutesData.recordedDate | date: 'yyyy-MM-dd' }}
                            </div>
                        </div>

                        <!-- Meeting Summary -->
                        <div class="meeting-summary-section mb-4">
                            <h5 class="section-title">Meeting Summary</h5>
                            <p class="summary-text">{{ meetingDetails!.meetingMinutesData.summary }}</p>
                        </div>

                        <!-- Attendance Table -->
                        <div class="attendance-table-section mb-4" *ngIf="meetingDetails!.meetingMinutesData.attendanceTable && meetingDetails!.meetingMinutesData.attendanceTable.length > 0">
                            <h5 class="section-title">Attendance:</h5>
                            <div class="table-responsive">
                                <table class="attendance-table">
                                    <thead>
                                        <tr>
                                            <th>الرقم</th>
                                            <th>اسم العضو</th>
                                            <th>الصفة</th>
                                            <th>حضور الإجتماع</th>
                                            <th>Attendance</th>
                                            <th>Role</th>
                                            <th>Member Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let member of getSortedAttendanceTable(); trackBy: trackByAttendanceMember">
                                            <td>{{ member.number }}</td>
                                            <td>{{ member.memberNameArabic }}</td>
                                            <td>{{ member.roleArabic }}</td>
                                            <td>
                                                <svg *ngIf="member.attendance" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="check-icon">
                                                    <path d="M9.99935 18.3332C14.6017 18.3332 18.3327 14.6022 18.3327 9.99984C18.3327 5.39746 14.6017 1.6665 9.99935 1.6665C5.39698 1.6665 1.66602 5.39746 1.66602 9.99984C1.66602 14.6022 5.39698 18.3332 9.99935 18.3332Z" stroke="#00A63E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7.5 10.0002L9.16667 11.6668L12.5 8.3335" stroke="#00A63E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </td>
                                            <td>
                                                <svg *ngIf="member.attendance" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="check-icon">
                                                    <path d="M9.99935 18.3332C14.6017 18.3332 18.3327 14.6022 18.3327 9.99984C18.3327 5.39746 14.6017 1.6665 9.99935 1.6665C5.39698 1.6665 1.66602 5.39746 1.66602 9.99984C1.66602 14.6022 5.39698 18.3332 9.99935 18.3332Z" stroke="#00A63E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7.5 10.0002L9.16667 11.6668L12.5 8.3335" stroke="#00A63E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </td>
                                            <td>{{ member.roleEnglish }}</td>
                                            <td>{{ member.memberNameEnglish }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Agenda Description -->
                        <fieldset class="content-fieldset mb-4" *ngIf="meetingDetails!.meetingMinutesData.agendaDescription">
                            <legend class="section-legend">Agenda Description</legend>
                            <div class="agenda-description-content">
                                <div class="agenda-description-subsection">
                                    <h6 class="subsection-title">English</h6>
                                    <p class="agenda-description-english">{{ meetingDetails!.meetingMinutesData.agendaDescription.english }}</p>
                                </div>
                                <div class="agenda-description-subsection">
                                    <h6 class="subsection-title">العربية</h6>
                                    <p class="agenda-description-arabic">{{ meetingDetails!.meetingMinutesData.agendaDescription.arabic }}</p>
                                </div>
                            </div>
                        </fieldset>

                        <!-- Items -->
                        <div class="items-section mb-4" *ngIf="meetingDetails!.meetingMinutesData.items && meetingDetails!.meetingMinutesData.items.length > 0">
                            <fieldset class="content-fieldset mb-4" *ngFor="let item of meetingDetails!.meetingMinutesData.items; trackBy: trackByMeetingItem">
                                <legend class="section-legend">Item #{{ item.itemNumber }} - {{ item.company }}</legend>
                                <div class="item-text-content">
                                    <div class="item-text-english">
                                        <p class="item-intro-text">{{ item.englishText }}</p>
                                        <p class="decision-label">Tender Committee Decision:</p>
                                        <div class="decision-text" [innerHTML]="getTrustedDecisionHtml(item.decisionEnglish, 'No TC Decision in English...')"></div>
                                    </div>
                                    <div class="item-text-arabic">
                                        <p class="item-intro-text">{{ item.arabicText }}</p>
                                        <p class="decision-label">قرار لجنة المناقصات:</p>
                                        <div class="decision-text" [innerHTML]="getTrustedDecisionHtml(item.decisionArabic, 'No TC Decision in Arabic...')"></div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <!-- Export PDF Button -->
                        <div class="export-pdf-container">
                            <button class="btn export-pdf-btn" (click)="exportMinutesAsPDF()">
                                <i class="fas fa-download me-2"></i>
                                Export Minutes as PDF
                            </button>
                        </div>
                    </div>
                    <div class="meeting-minutes-content" *ngIf="!meetingDetails?.meetingMinutesData && (!attendanceTableData || attendanceTableData.length === 0) && (!agendaItemsWithDecisions || agendaItemsWithDecisions.length === 0)">
                        <p class="no-minutes-text">No minutes recorded yet</p>
                    </div>
                </fieldset>
            </div>

            <!-- Right Column -->
            <div class="col-12 col-md-4">
                <!-- Meeting Information Section -->
                <fieldset class="content-fieldset mb-4">
                    <legend class="section-legend">Meeting Information</legend>
                    <div class="info-item mb-3">
                        <div class="info-label">Meeting ID:</div>
                        <div class="info-value">{{ meetingDetails?.meetingId }}</div>
                    </div>
                    <div class="info-item mb-3">
                        <div class="info-label">Emergency Meeting:</div>
                        <div class="info-value">
                            <span [class]="meetingDetails?.isEmergencyMeeting ? 'badge bg-warning text-dark' : 'badge bg-secondary'">
                                {{ meetingDetails?.isEmergencyMeeting ? 'Yes' : 'No' }}
                            </span>
                        </div>
                    </div>
                    <div class="info-item mb-3">
                        <div class="info-label">Created By:</div>
                        <div class="info-value">{{ meetingDetails?.createdBy }}</div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">Created Date:</div>
                        <div class="info-value">{{ meetingDetails?.createdDate | date: 'MMMM d, yyyy' }}</div>
                    </div>
                    <div class="info-item mt-3">
                        <button class="btn documents-btn w-100" (click)="openMeetingDocumentsDialog()" aria-label="View Documents">
                            <i class="fas fa-file-alt me-2"></i>
                            Documents
                            <span *ngIf="meetingAttachments.length > 0" class="badge ms-2">{{ meetingAttachments.length }}</span>
                        </button>
                    </div>
                </fieldset>

                <!-- Members Invited Section -->
                <fieldset class="content-fieldset">
                    <legend class="section-legend">Members Invited</legend>
                    <div class="members-list-view" *ngIf="meetingDetails?.members && meetingDetails!.members.length > 0">
                        <div *ngFor="let member of getSortedMembers(); trackBy: trackByMember" class="member-card">
                            <div class="member-avatar">
                                {{ member.initials }}
                            </div>
                            <div class="member-details">
                                <div class="member-name">{{ member.name }}</div>
                                <div class="member-role">{{ member.role }}</div>
                            </div>
                            <div class="member-status">
                                <app-status-badge 
                                    [text]="member.status || 'Pending'"
                                    [color]="getMemberStatusColor(member.status || 'Pending')"
                                    [size]="'small'">
                                </app-status-badge>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            </fieldset>
        </div>
    </div>

    <!-- Attachments Dialog -->
    <div class="attachments-dialog-overlay" *ngIf="showAttachmentsDialog" (click)="closeAttachmentsDialog()">
        <div class="attachments-dialog" (click)="$event.stopPropagation()">
            <!-- Header -->
            <div class="dialog-header">
                <div class="header-content">
                    <h3 class="dialog-title">Attachments</h3>
                    <p class="dialog-subtitle">{{ currentAgendaItemSubject }}</p>
                </div>
                <button class="close-btn" (click)="closeAttachmentsDialog()" aria-label="Close">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

            <!-- Content -->
            <div class="dialog-content">
                <div class="attachments-list" *ngIf="currentAttachments.length > 0">
                    <div *ngFor="let attachment of currentAttachments; trackBy: trackByAttachment" class="attachment-item">
                        <div class="attachment-icon">
                            <div class="file-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="48" height="48" rx="8" fill="#F3E8F5"/>
                                    <g transform="translate(10, 10) scale(1.4)">
                                        <path d="M12.4987 1.66675H4.9987C4.55667 1.66675 4.13275 1.84234 3.82019 2.1549C3.50763 2.46746 3.33203 2.89139 3.33203 3.33341V16.6667C3.33203 17.1088 3.50763 17.5327 3.82019 17.8453C4.13275 18.1578 4.55667 18.3334 4.9987 18.3334H14.9987C15.4407 18.3334 15.8646 18.1578 16.1772 17.8453C16.4898 17.5327 16.6654 17.1088 16.6654 16.6667V5.83341L12.4987 1.66675Z" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.668 1.66675V5.00008C11.668 5.44211 11.8436 5.86603 12.1561 6.17859C12.4687 6.49115 12.8926 6.66675 13.3346 6.66675H16.668" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8.33464 7.5H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.3346 10.8333H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.3346 14.1667H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="attachment-info">
                            <div class="attachment-name" [title]="attachment.name">{{ attachment.name }}</div>
                            <div class="attachment-meta">
                                {{ attachment.size }} • Uploaded by {{ attachment.uploadedBy }}
                            </div>
                        </div>
                        <div class="attachment-actions">
                            <button class="btn btn-sm preview-btn" (click)="previewAttachment(attachment)" aria-label="Preview" title="Preview">
                                <i class="fas fa-eye"></i>
                            </button>
                            <button class="btn btn-sm download-btn" (click)="downloadFile(attachment)" aria-label="Download" title="Download">
                                <i class="fas fa-download"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="no-attachments" *ngIf="currentAttachments.length === 0 && !isLoadingAttachments">
                    <p>No attachments available</p>
                </div>
                <div class="loading-attachments" *ngIf="isLoadingAttachments">
                    <p>Loading attachments...</p>
                </div>
            </div>

            <!-- Footer -->
            <div class="dialog-footer">
                <button class="btn close-button" (click)="closeAttachmentsDialog()">Close</button>
            </div>
        </div>
    </div>

    <!-- Meeting Documents Dialog -->
    <div class="attachments-dialog-overlay" *ngIf="showMeetingDocumentsDialog" (click)="closeMeetingDocumentsDialog()">
        <div class="attachments-dialog" (click)="$event.stopPropagation()">
            <!-- Header -->
            <div class="dialog-header">
                <div class="header-content">
                    <h3 class="dialog-title">Documents</h3>
                </div>
                <button class="close-btn" (click)="closeMeetingDocumentsDialog()" aria-label="Close">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

            <!-- Content -->
            <div class="dialog-content">
                <div class="attachments-list" *ngIf="meetingAttachments.length > 0">
                    <div *ngFor="let attachment of meetingAttachments; trackBy: trackByAttachment" class="attachment-item">
                        <div class="attachment-icon">
                            <div class="file-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="48" height="48" rx="8" fill="#F3E8F5"/>
                                    <g transform="translate(10, 10) scale(1.4)">
                                        <path d="M12.4987 1.66675H4.9987C4.55667 1.66675 4.13275 1.84234 3.82019 2.1549C3.50763 2.46746 3.33203 2.89139 3.33203 3.33341V16.6667C3.33203 17.1088 3.50763 17.5327 3.82019 17.8453C4.13275 18.1578 4.55667 18.3334 4.9987 18.3334H14.9987C15.4407 18.3334 15.8646 18.1578 16.1772 17.8453C16.4898 17.5327 16.6654 17.1088 16.6654 16.6667V5.83341L12.4987 1.66675Z" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11.668 1.66675V5.00008C11.668 5.44211 11.8436 5.86603 12.1561 6.17859C12.4687 6.49115 12.8926 6.66675 13.3346 6.66675H16.668" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8.33464 7.5H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.3346 10.8333H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.3346 14.1667H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="attachment-info">
                            <div class="attachment-name" [title]="attachment.name">{{ attachment.name }}</div>
                            <div class="attachment-meta">
                                {{ attachment.size }} • Uploaded by {{ attachment.uploadedBy }}
                            </div>
                        </div>
                        <div class="attachment-actions">
                            <button class="btn btn-sm preview-btn" (click)="previewAttachment(attachment)" aria-label="Preview" title="Preview">
                                <i class="fas fa-eye"></i>
                            </button>
                            <button class="btn btn-sm download-btn" (click)="downloadFile(attachment)" aria-label="Download" title="Download">
                                <i class="fas fa-download"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="no-attachments" *ngIf="meetingAttachments.length === 0 && !isLoadingMeetingAttachments">
                    <p>No attachments available</p>
                </div>
                <div class="loading-attachments" *ngIf="isLoadingMeetingAttachments">
                    <p>Loading attachments...</p>
                </div>
            </div>

            <!-- Footer -->
            <div class="dialog-footer">
                <button class="btn close-button" (click)="closeMeetingDocumentsDialog()">Close</button>
            </div>
        </div>
    </div>
</div>
